import {
  AssetType,
  CurrencyCode,
  MarketTradeContractResponse,
  RegistryCode,
  TradeContractStatus,
  TradePosition,
  TradeType,
} from "@/app/types/generated/graphql";

export const demoMarketOrders = {
  data: {
    totalAsks: 5332,
    totalBids: 17044,
    __typename: "MarketOrderData",
  },
  offsetInfo: {
    offset: 9,
    limit: 20,
    total: 9,
    __typename: "PageDetail",
  },
  orders: [
    {
      id: "f47f2224-5eac-4076-b20a-3f6550d36a60",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Ask,
      status: "OPEN",
      initialVolume: 2057,
      currentVolume: 2057,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.343Z",
      orderNumber: "20231024-CPJ6",
      allowCounterOffers: true,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.823Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3590"],
        fuelSources: ["H2O"],
        eligibilities: ["sd"],
        certifications: [],
        commencementDate: "2008-10-01",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: true,
    },
    {
      id: "572a8cef-6bb0-4b42-bd51-86803c8e03ec",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Bid,
      status: "OPEN",
      initialVolume: 6240,
      currentVolume: 6240,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.152Z",
      orderNumber: "20231024-IJW1",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.823Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3592"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: [],
        commencementDate: "1995-03-01",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "86d28fc3-bb65-4719-9364-e88255745654",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Ask,
      status: "OPEN",
      initialVolume: 653,
      currentVolume: 653,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.084Z",
      orderNumber: "20231024-KIJ1",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3566"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: "1902-09-17",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "ecba5198-b34b-4826-a3c4-7103fc2ba424",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Ask,
      status: "OPEN",
      initialVolume: 339,
      currentVolume: 339,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.084Z",
      orderNumber: "20231024-BZ2B",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3848"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: "1991-01-02",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "63e957ad-841b-4721-886f-32909bf1f5c6",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Bid,
      status: "OPEN",
      initialVolume: 3143,
      currentVolume: 3143,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.081Z",
      orderNumber: "20231024-OM4K",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3594"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: [],
        commencementDate: "2005-12-01",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "9413cd41-b52d-4250-a808-7b1c8cbcf9a9",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Ask,
      status: "OPEN",
      initialVolume: 1131,
      currentVolume: 1131,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.078Z",
      orderNumber: "20231024-FD2P",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M4107"],
        fuelSources: ["H2O"],
        eligibilities: ["nd"],
        certifications: [],
        commencementDate: "2021-01-20",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "d9329313-e2cb-49de-b272-e6dc42374a93",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Bid,
      status: "OPEN",
      initialVolume: 1170,
      currentVolume: 1170,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.076Z",
      orderNumber: "20231024-XDXB",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3595"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: [],
        commencementDate: "2007-01-01",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "96d23dd5-c828-461a-b421-a0a07db8867e",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Bid,
      status: "OPEN",
      initialVolume: 6491,
      currentVolume: 6491,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.076Z",
      orderNumber: "20231024-FQI1",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3589"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: [],
        commencementDate: "1997-12-01",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
    {
      id: "c774d2f0-66f6-427b-aeb1-031bde50e071",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      account: {
        id: "2cf2d7f4-5b66-407f-8708-18cbd0e74473",
        __typename: "Account",
      },
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: TradePosition.Ask,
      status: "OPEN",
      initialVolume: 1152,
      currentVolume: 1152,
      completedOn: null,
      createdOn: "2023-10-24T12:30:10.074Z",
      orderNumber: "20231024-KFN1",
      allowCounterOffers: false,
      type: "LIMIT",
      price: {
        currencyCode: CurrencyCode.Usd,
        amount: "90",
        __typename: "Money",
      },
      updatedOn: "2024-02-06T04:02:54.822Z",
      attributes: {
        vintages: ["2022-FRONT_HALF"],
        locations: ["AK"],
        projects: ["M3847"],
        fuelSources: ["H2O"],
        eligibilities: [],
        certifications: [],
        commencementDate: "2002-01-02",
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "Order",
      canCounter: false,
    },
  ],
  __typename: "MarketOrderResponse",
};
export const demoMarketTradeContracts: MarketTradeContractResponse = {
  marketTradeContracts: [
    {
      id: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
      accountId: "14d58dbb-2122-4810-99c8-ee764e35c714",
      position: TradePosition.Ask,
      volume: 15000,
      unitPrice: 210,
      currencyCode: CurrencyCode.Usd,
      tradeSettlementDate: "2026-11-06",
      assetType: AssetType.Rec,
      status: TradeContractStatus.Open,
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1UIG75AJY8",
      tradeType: TradeType.Forward,
      createdDate: "2025-11-13T04:54:09.091Z",
      registryCode: null,
      attributes: {
        vintages: ["2023-FRONT_HALF", "2023-BACK_HALF"],
        locations: [],
        projects: null,
        fuelSources: ["WND"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "MarketTradeContract",
    },
    {
      id: "38704fd3-d819-471e-9faf-836e2836f47c",
      accountId: "14d58dbb-2122-4810-99c8-ee764e35c714",
      position: TradePosition.Bid,
      volume: 150000,
      unitPrice: 130,
      currencyCode: CurrencyCode.Usd,
      tradeSettlementDate: "2027-11-01",
      assetType: AssetType.Rec,
      status: TradeContractStatus.Open,
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1UIG75AJY8",
      tradeType: TradeType.Forward,
      createdDate: "2025-11-13T04:53:07.951Z",
      registryCode: null,
      attributes: {
        vintages: ["2023-FRONT_HALF", "2023-BACK_HALF"],
        locations: ["MN"],
        projects: null,
        fuelSources: ["SO1"],
        eligibilities: [],
        certifications: ["ecologo"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "MarketTradeContract",
    },
    {
      id: "07aed618-18b9-4c22-82d0-4be1c86afce0",
      accountId: "14d58dbb-2122-4810-99c8-ee764e35c714",
      position: TradePosition.Bid,
      volume: 100000,
      unitPrice: 150,
      currencyCode: CurrencyCode.Usd,
      tradeSettlementDate: "2026-12-04",
      assetType: AssetType.Rec,
      status: TradeContractStatus.Open,
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1UIG75AJY8",
      tradeType: TradeType.Forward,
      createdDate: "2025-11-13T04:52:00.506Z",
      registryCode: RegistryCode.Ercot,
      attributes: {
        vintages: ["2024-Q4", "2024-Q3", "2024-Q2", "2024-Q1"],
        locations: ["TX"],
        projects: null,
        fuelSources: ["WND"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      __typename: "MarketTradeContract",
    },
    {
      id: "9d814190-96d5-4edc-86a9-804fd5968b35",
      accountId: "9bd13ba7-bc4e-4d88-a292-0fdea0c36e66",
      position: TradePosition.Ask,
      volume: 20,
      unitPrice: 2000,
      currencyCode: CurrencyCode.Usd,
      tradeSettlementDate: "2027-11-30",
      assetType: AssetType.Rec,
      status: TradeContractStatus.Open,
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1UIG75AJY8",
      tradeType: TradeType.Forward,
      createdDate: "2025-11-06T02:21:24.215Z",
      registryCode: RegistryCode.Ercot,
      attributes: {
        vintages: ["2023-Q4", "2023-Q3", "2023-Q2", "2023-Q1"],
        locations: ["TX"],
        projects: null,
        fuelSources: ["LFG", "H20", "TI"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: "2022-11-06",
        certificateTypes: ["CP", "R"],
        __typename: "RecAttributes",
      },
      __typename: "MarketTradeContract",
    },
  ],
  offsetInfo: {
    offset: 0,
    limit: 20,
    total: 4,
    __typename: "PageDetail",
  },
  __typename: "MarketTradeContractResponse",
};

export const demoOrderHistory = {
  orderHistories: [
    {
      id: "fc383cc8-fabf-4988-927a-14bebd382198",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      accountId: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      orderNumber: "ON-1UAH59XJLS",
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: "BID",
      type: "LIMIT",
      status: "FAILED",
      statusMessage: "Insufficient balance",
      initialVolume: 50000,
      currentVolume: 50000,
      cancelledVolume: 0,
      price: {
        amount: "202",
        currencyCode: CurrencyCode.Usd,
        __typename: "Money",
      },
      allowCounterOffers: false,
      projectVisibility: true,
      completedOn: "2025-10-14T18:51:14.521Z",
      createdOn: "2025-10-14T18:51:14.072Z",
      updatedOn: "2025-10-14T18:51:14.521Z",
      attributes: {
        vintages: ["2024-BACK_HALF"],
        locations: [
          "AL",
          "AK",
          "AS",
          "AZ",
          "AR",
          "AA",
          "AE",
          "AP",
          "CA",
          "CO",
          "CT",
          "DE",
          "DC",
          "FL",
          "GA",
          "GU",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MH",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "NP",
          "OH",
          "OK",
          "OR",
          "PA",
          "PR",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UM",
          "VI",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY",
        ],
        projects: [],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      orderExpiry: "GTC",
      expiryDate: null,
      __typename: "OrderHistory",
    },
    {
      id: "9dc21186-e1bc-4117-b472-65c938377a87",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      accountId: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      orderNumber: "ON-1RPQDJSMPS",
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: "BID",
      type: "LIMIT",
      status: TradeContractStatus.Withdrawn,
      statusMessage: "Order withdrawn at 17:42 UTC 11-14-2025",
      initialVolume: 55000,
      currentVolume: 0,
      cancelledVolume: 55000,
      price: {
        amount: "170",
        currencyCode: CurrencyCode.Usd,
        __typename: "Money",
      },
      allowCounterOffers: false,
      projectVisibility: true,
      completedOn: null,
      createdOn: "2025-07-24T15:20:36.650Z",
      updatedOn: "2025-11-14T17:42:21.329Z",
      attributes: {
        vintages: ["2024-BACK_HALF"],
        locations: [],
        projects: [],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      orderExpiry: "GTC",
      expiryDate: null,
      __typename: "OrderHistory",
    },
    {
      id: "6cabc124-3d75-418c-a925-bbaa8d8259bf",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      accountId: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      orderNumber: "ON-1RB4OJCU68",
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: "BID",
      type: "LIMIT",
      status: "FAILED",
      statusMessage: "Insufficient balance",
      initialVolume: 50000,
      currentVolume: 50000,
      cancelledVolume: 0,
      price: {
        amount: "200",
        currencyCode: CurrencyCode.Usd,
        __typename: "Money",
      },
      allowCounterOffers: false,
      projectVisibility: true,
      completedOn: "2025-07-11T16:55:34.048Z",
      createdOn: "2025-07-11T16:55:33.601Z",
      updatedOn: "2025-07-11T16:55:34.049Z",
      attributes: {
        vintages: ["2025-FRONT_HALF"],
        locations: [],
        projects: ["M22318"],
        fuelSources: [],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      orderExpiry: "GTC",
      expiryDate: null,
      __typename: "OrderHistory",
    },
    {
      id: "6e27c115-821a-474e-891d-e55558fb5a2f",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      accountId: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      orderNumber: "ON-1RB4MEBWWW",
      registryCode: RegistryCode.Mrets,
      assetType: AssetType.Rec,
      position: "BID",
      type: "LIMIT",
      status: "COMPLETE",
      statusMessage: "",
      initialVolume: 500,
      currentVolume: 0,
      cancelledVolume: 0,
      price: {
        amount: "506",
        currencyCode: CurrencyCode.Usd,
        __typename: "Money",
      },
      allowCounterOffers: false,
      projectVisibility: true,
      completedOn: "2025-07-16T16:44:18.791Z",
      createdOn: "2025-07-11T16:53:27.262Z",
      updatedOn: "2025-07-16T16:44:18.792Z",
      attributes: {
        vintages: ["2024-BACK_HALF"],
        locations: [],
        projects: ["M3596"],
        fuelSources: ["SO1"],
        eligibilities: [],
        certifications: ["CRS"],
        commencementDate: null,
        certificateTypes: [],
        __typename: "RecAttributes",
      },
      orderExpiry: "GTC",
      expiryDate: null,
      __typename: "OrderHistory",
    },
  ],
  offsetInfo: {
    limit: 20,
    offset: 4,
    total: 4,
    __typename: "PageDetail",
  },
  __typename: "OrderHistoryResponse",
};

export const demoTradeContractHistory = {
  offsetInfo: {
    offset: 0,
    limit: 20,
    total: 10,
    __typename: "PageDetail",
  },
  tradeContracts: [
    {
      id: "3f5cdb35-e689-4db9-884e-5aaddd4ef007",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1UIG75AJY8",
      createdDate: "2025-10-21T20:21:18.826Z",
      tradeSettlementDate: "2026-03-31",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-31",
        contractedPaymentDate: "2026-03-31",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-11-14T17:43:02.680Z",
      volume: 35000,
      statusMessage: null,
      status: TradeContractStatus.PendingReview,
      registryCode: RegistryCode.Mrets,
      unitPrice: 225,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: ["TX"],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "f97e2479-b97e-4833-8148-b467d7dfede9",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1SLA4RXRWG",
      createdDate: "2025-08-21T13:59:46.462Z",
      tradeSettlementDate: "2026-03-29",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-29",
        contractedPaymentDate: "2026-03-29",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-08-21T13:59:46.462Z",
      volume: 85000,
      statusMessage: "",
      status: "CONTRACTED",
      registryCode: RegistryCode.Mrets,
      unitPrice: 222,
      position: "BID",
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: ["UM", "VI", "UT", "VT", "VA", "WA", "WV", "WI", "WY"],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "3265b4a8-e40f-4f32-ad7f-804177afc1a9",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1TY4L2F934",
      createdDate: "2025-10-03T20:20:41.557Z",
      tradeSettlementDate: "2026-03-31",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-31",
        contractedPaymentDate: "2026-03-31",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-11-14T17:42:58.197Z",
      volume: 50000,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Mrets,
      unitPrice: 225,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: ["AL", "AK", "AS", "AZ", "WV", "WI", "WY"],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "4e9836ed-7dfb-4893-8c58-3958b48ff70a",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1TY4I48T6O",
      createdDate: "2025-10-03T20:17:47.397Z",
      tradeSettlementDate: "2026-03-31",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-31",
        contractedPaymentDate: "2026-03-31",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-10-21T20:19:30.400Z",
      volume: 50000,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Mrets,
      unitPrice: 225,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: ["AL", "AK", "AS", "WI", "WY"],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "a6d3dcc2-2ecf-4a48-aec6-b3beab44ec15",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1RU6M5BPUO",
      createdDate: "2025-07-28T13:57:46.594Z",
      tradeSettlementDate: "2026-03-29",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-29",
        contractedPaymentDate: "2026-03-29",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-11-14T17:42:52.684Z",
      volume: 25000,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Mrets,
      unitPrice: 215,
      position: "BID",
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: [],
        fuelSources: ["WND", "SO1"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: "2020-07-28",
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "5eae46c1-2e03-4a86-8a2e-6c9236de5fca",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1RPQI8BBCW",
      createdDate: "2025-07-24T15:25:13.085Z",
      tradeSettlementDate: "2026-03-29",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-29",
        contractedPaymentDate: "2026-03-29",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-07-28T13:55:01.259Z",
      volume: 25000,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Mrets,
      unitPrice: 210,
      position: "BID",
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-BACK_HALF"],
        locations: [],
        fuelSources: ["SO1", "WND"],
        eligibilities: [],
        projects: null,
        certifications: ["CRS"],
        certificateTypes: null,
        commencementDate: "2020-07-24",
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "0585e186-1ea8-4eb7-b2ad-86960a5bd7ba",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1T6XNF5IQO",
      createdDate: "2025-09-09T18:17:37.604Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-09-09T18:17:37.604Z",
      volume: 50000,
      statusMessage: "",
      status: "COMPLETED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 199,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q2", "2025-Q1"],
        locations: null,
        fuelSources: ["WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: ["R"],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "d63e6a98-aa93-45ca-8106-4344eeb9c36f",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1T6XLRQFB4",
      createdDate: "2025-09-09T18:16:00.115Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-09-09T18:16:00.115Z",
      volume: 50000,
      statusMessage: "",
      status: "COMPLETED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 199,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q2", "2025-Q1"],
        locations: null,
        fuelSources: ["SO", "WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: ["R", "CP"],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "7f62ae1e-7d8f-4d73-8aaf-f63fdcb25724",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1T6VLMN08W",
      createdDate: "2025-09-09T17:05:00.231Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-09-09T17:05:00.231Z",
      volume: 25000,
      statusMessage: "",
      status: "COMPLETED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 200,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q1", "2025-Q2"],
        locations: null,
        fuelSources: ["WND", "SO"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "6214bc7d-58db-466d-8a55-40528b7e63ce",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1T6VKA4F0G",
      createdDate: "2025-09-09T17:03:40.652Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-09-09T17:03:40.652Z",
      volume: 75000,
      statusMessage: "",
      status: "COMPLETED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 200,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q2", "2025-Q1"],
        locations: null,
        fuelSources: ["WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "8db00b68-0caf-43da-927b-63a0abd95349",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1T6VHWC5J4",
      createdDate: "2025-09-09T17:01:19.943Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-09-09T18:18:36.022Z",
      volume: 100000,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Ercot,
      unitPrice: 199,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q1", "2025-Q2"],
        locations: null,
        fuelSources: ["WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "72ec2ba8-cad0-409c-b754-24a5fa76fcda",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1SMJDNITTS",
      createdDate: "2025-08-22T16:42:50.041Z",
      tradeSettlementDate: "2025-09-30",
      matchedTrade: {
        contractedDeliveryDate: "2025-09-30",
        contractedPaymentDate: "2025-09-30",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-08-22T16:42:50.041Z",
      volume: 30944,
      statusMessage: "",
      status: "COMPLETED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 195,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q1", "2025-Q2"],
        locations: null,
        fuelSources: ["WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
    {
      id: "25dfeef4-3528-4165-ae01-2cd5d3fbbd70",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1SLKXPLSW0",
      createdDate: "2025-08-21T20:22:32.697Z",
      tradeSettlementDate: "2026-03-31",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-31",
        contractedPaymentDate: "2026-03-31",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-08-22T16:41:42.688Z",
      volume: 30944,
      statusMessage: null,
      status: TradeContractStatus.Withdrawn,
      registryCode: RegistryCode.Ercot,
      unitPrice: 195,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q1", "2025-Q2"],
        locations: null,
        fuelSources: ["WND"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: null,
      __typename: "TradeContract",
    },
    {
      id: "78764e81-07bd-470e-aee5-a3cba4eabc98",
      tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
      tradeContractNumber: "TC-1SLDWA6FSW",
      createdDate: "2025-08-21T16:13:07.995Z",
      tradeSettlementDate: "2026-03-31",
      matchedTrade: {
        contractedDeliveryDate: "2026-03-31",
        contractedPaymentDate: "2026-03-31",
        matchedTradeContractId: "30b5d1ca-b34c-402f-8867-d3b156a2a7cb",
        tradeContractChangeRequests: [],
      },
      tradeType: TradeType.Forward,
      updatedOn: "2025-08-21T16:13:07.995Z",
      volume: 50000,
      statusMessage: "",
      status: "CONTRACTED",
      registryCode: RegistryCode.Ercot,
      unitPrice: 221,
      position: TradePosition.Ask,
      currencyCode: CurrencyCode.Usd,
      assetType: AssetType.Rec,
      hasActionableChangeRequest: false,
      attributes: {
        vintages: ["2025-Q4", "2025-Q3"],
        locations: null,
        fuelSources: ["WND", "SO"],
        eligibilities: null,
        projects: null,
        certifications: ["CRS"],
        certificateTypes: [],
        commencementDate: null,
        __typename: "RecAttributes",
      },
      account: {
        id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
        company: {
          businessName: "Power Ledger Inc.",
          id: "bcfac496-9602-47b6-8271-f2a935c4263c",
          __typename: "Company",
        },
        __typename: "Account",
      },
      counterAccount: {
        id: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
        email: "demo@democommodities.com",
        businessName: "Demo Commodities Inc.",
        __typename: "SimpleAccount",
      },
      __typename: "TradeContract",
    },
  ],
  __typename: "TradeContractResponse",
};

export const demoTradeContractById = {
  id: "e73d65c9-a83d-4858-bf24-557508732ed5",
  tenantId: "08cd2505-18d4-488b-a960-2195463332e8",
  account: {
    id: "14d58dbb-2122-4810-99c8-ee764e35c714",
    company: {
      businessName: "Demo Commodities Inc.",
      id: "2feca8e2-3aff-4b41-874e-a09592e7e6e5",
      __typename: "Company",
    },
    __typename: "Account",
  },
  unitPrice: 225,
  volume: 35000,
  status: "PENDING_REVIEW",
  tradeContractNumber: "TC-1V7P88CXLS",
  tradeSettlementDate: "2026-03-31",
  hasActionableChangeRequest: false,
  matchedTrade: {
    contractedDeliveryDate: "2026-03-31",
    contractedPaymentDate: "2026-03-31",
    matchedTradeContractId: "49d0e485-1b74-42f5-a466-d7d35df7b63b",
    tradeContractChangeRequests: [],
    __typename: "MatchedTrade",
  },
  attributes: {
    vintages: ["2025-BACK_HALF"],
    locations: ["TX"],
    fuelSources: ["WND", "SO1"],
    eligibilities: [],
    projects: null,
    certifications: ["CRS"],
    certificateTypes: null,
    commencementDate: null,
    __typename: "RecAttributes",
  },
  __typename: "TradeContract",
};
